import backendData from "../store/backend-data";

export function getFormDataFailureModes() {
  return backendData.form_data_failure_modes;
}

export function getFormDataProjectPhases(failureId: string) {
  const data = backendData as Record<string, any>;
  return Object.keys(data.solution_table[failureId]).map(
    id => data.form_data_project_phases[id]
  );
}

export function getFormDataCauses(failureId: string, phaseId: string) {
  const data = backendData as Record<string, any>;
  return Object.keys(data.solution_table[failureId][phaseId]).map(
    id => data.form_data_causes[id]
  );
}

export function getSolution(failureId: string, causeId: string): string | undefined {
  const data = backendData as Record<string, any>;
  console.log(data.form_data_causes[causeId]);
  const phase_id = data.form_data_causes[causeId]?.parent;
  const solution_id = data.solution_table[failureId]?.[phase_id]?.[causeId];
  return data.solutions[solution_id];
}
